import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'STUDENT_COURSE_TRIAL_UPGRADE_POST',
  POST_SUCCESS: 'STUDENT_COURSE_TRIAL_UPGRADE_POST_SUCCESS',
  POST_FAILURE: 'STUDENT_COURSE_TRIAL_UPGRADE_POST_FAILURE',
  EMPTY_STORE_DATA: 'EMPTY_STORE_DATA',
};

export const post = actions.post(id => `${BASE_URL}/student-course-trial-upgrade/${id}`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const emptyStoreData = payload => dispatch => {
  dispatch({ type: ACTIONS.EMPTY_STORE_DATA, payload });
};
